import * as promptEnhancementConfig from '../../config/promptEnhancementConfig';
import { DEFAULT_ENHANCEMENT_MODEL } from '../../config/promptEnhancementDefaults';
import { generateSystemPromptByUseCase } from '../../config/promptEnhancementGenerator';

const ENHANCEMENT_USE_CASE_BY_TEMPLATE = Object.freeze({
  'text-to-image': 'text-to-image',
});

let repositoryLookup = () => null;

export function setRepositoryLookupForEnhancement(lookup) {
  repositoryLookup = typeof lookup === 'function' ? lookup : () => null;
}

function buildSystemPrompt({ templateId, modelName, notes }) {
  const useCase = ENHANCEMENT_USE_CASE_BY_TEMPLATE[templateId];
  if (!useCase) return null;

  const base = generateSystemPromptByUseCase(useCase, {
    modelName: modelName || 'this custom model',
  });
  const trimmedNotes = typeof notes === 'string' ? notes.trim() : '';
  if (!trimmedNotes) return base;
  return `${base}\n\nADMIN NOTES FOR ${modelName || 'this custom model'}: ${trimmedNotes}`;
}

export function resolveModelEnhancementConfig(moduleId) {
  if (typeof moduleId !== 'string') return null;
  const id = moduleId.trim();
  if (!id) return null;

  const model = repositoryLookup(id);
  if (!model || model.prompt?.enhancerId !== id) return null;

  const enhancement = model.prompt?.enhancement;
  if (!enhancement || typeof enhancement !== 'object') return null;

  const templateId = typeof enhancement.templateId === 'string'
    ? enhancement.templateId.trim()
    : '';
  if (!templateId) return null;

  const modelName = typeof enhancement.modelName === 'string' && enhancement.modelName.trim()
    ? enhancement.modelName.trim()
    : (typeof model.label === 'string' ? model.label : '');

  const systemPrompt = buildSystemPrompt({
    templateId,
    modelName,
    notes: enhancement.notes,
  });
  if (!systemPrompt) return null;

  return {
    systemPrompt,
    model: DEFAULT_ENHANCEMENT_MODEL,
    temperature: 0.8,
    maxTokens: 600,
  };
}

function safeReadExport(name) {
  try {
    return promptEnhancementConfig[name];
  } catch {
    return undefined;
  }
}

export function installDynamicModelEnhancementResolver() {
  const setter = safeReadExport('setDynamicEnhancementConfigResolver');
  if (typeof setter === 'function') {
    setter(resolveModelEnhancementConfig);
  }
}

export function uninstallDynamicModelEnhancementResolver() {
  const reset = safeReadExport('resetDynamicEnhancementConfigResolver');
  if (typeof reset === 'function') {
    reset();
  }
}
